// RoleFilter.jsx
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus, faChevronDown, faRotateRight, faClose, faSliders
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import customSelectStyles from "../../../components/ui/customSelectStyles";

const RoleFilter = ({ onNewClick, onFilterChange }) => {
  const [moreOpen, setMoreOpen] = useState(false);
  const [advanced, setAdvanced] = useState(false);
  const [filters, setFilters] = useState({
    keyword: "",
    module_id: "",
    is_active: "",
  });

  const moduleOptions = [
    { value: "crm", label: "CRM" },
    { value: "hrm", label: "HRM" },
    { value: "elearning", label: "E-Learning" },
    { value: "finance", label: "Finance" },
    { value: "reports", label: "Reports" },
    { value: "settings", label: "Settings" },
  ];

  const isActiveOptions = [
    { value: "active", label: "Active" },
    { value: "isactive", label: "Inactive" },
  ];

  const isFiltering = Object.values(filters).some((v) => v !== "");

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    onFilterChange?.(newFilters);
  };

  const clearFilters = () => {
    const cleared = {
      keyword: "",
      module_id: "",
      is_active: "",
    };
    setFilters(cleared);
    onFilterChange?.(cleared);
  };

  const refreshData = () => {
    onFilterChange?.({ ...filters });
  };

  return (
    // <div className="flex justify-end mb-4">
    //   <button
    //     onClick={onNewClick}
    //     className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
    //   >
    //     New permission
    //   </button>
    // </div>

    <div className="flex flex-col gap-2 mb-4">
      {/* Dòng trên cùng */}
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div className="flex flex-wrap gap-3 items-end">
          <div className="flex flex-col">
            <input
              name="keyword"
              value={filters.keyword}
              onChange={handleChange}
              type="text"
              placeholder="Enter keyword here"
              className="border px-3 py-2 rounded w-72 max-w-full"
            />
          </div>

          <button
            onClick={refreshData}
            className="h-[42px] w-[42px] bg-white border text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
            title="Làm mới"
          >
            <FontAwesomeIcon icon={faRotateRight} />
          </button>

          <button
            onClick={() => setAdvanced(!advanced)}
            className="h-[42px] w-[42px] bg-white border text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
            title={advanced ? "Ẩn lọc nâng cao" : "Lọc nâng cao"}
          >
            <FontAwesomeIcon icon={faSliders} />
          </button>
        </div>

        <button
          onClick={onNewClick}
          className="h-[42px] flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          <FontAwesomeIcon icon={faPlus} />
          New Role
        </button>
      </div>

      {/* Dòng lọc nâng cao */}
      {advanced && (
        <div className="flex flex-wrap items-end gap-3 mt-2">
          <div className="flex flex-col">
            <label className="text-sm text-gray-600 mb-1">Modules / Functions</label>
            <Select
              styles={customSelectStyles}
              options={moduleOptions}
              placeholder="--- Select ---"
              value={moduleOptions.find(opt => opt.value === filters.module_id) || null}
              onChange={(selectedOption) => {
                setFilters((prev) => ({
                  ...prev,
                  status: selectedOption?.value || "",
                }));
                onFilterChange?.({
                  ...filters,
                  status: selectedOption?.value || "",
                });
              }}
              isClearable
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-600 mb-1">Is active</label>
            <Select
              styles={customSelectStyles}
              options={isActiveOptions}
              placeholder="--- Select ---"
              value={isActiveOptions.find(opt => opt.value === filters.is_active) || null}
              onChange={(selectedOption) => {
                setFilters((prev) => ({
                  ...prev,
                  status: selectedOption?.value || "",
                }));
                onFilterChange?.({
                  ...filters,
                  status: selectedOption?.value || "",
                });
              }}
              isClearable
            />
          </div>

          {isFiltering && (
            <button
              onClick={clearFilters}
              className="h-[42px] w-[42px] bg-white border text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
              title="Xóa lọc"
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
          )}
        </div>
      )}


    </div>
  );
};

export default RoleFilter;